module.exports = __webpack_public_path__ + "static/abstract_1-ed43e5e70aebb6465ea095a8709c42db.jpg";